<template>
  <div class="poster-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="market:poster:activity:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建活动页</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #id="{ row }">{{ row.id }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #remark="{ row }">
        <div class="remark">{{ row.remark }}</div>
      </template>
      <template #createdTime="{ row }">{{ row.createdTime }}</template>
      <template #posterNum="{ row }">{{ row.posterNum }}</template>
      <template #disable="{ row }">{{ row.disable ? '关闭' : '开启' }}</template>
      <template #operation="{ scope }">
        <auth-button auth="market:poster:activity:update">
          <el-button type="text" @click="onSwitch(scope.row)" :class="!scope.row.disable ? 'mr10 ' + 'del' : 'mr10'">{{ scope.row.disable ? '开启' : '关闭' }}</el-button>
        </auth-button>
        <auth-button auth="market:poster:activity:update">
          <el-button class="mr10" type="text" @click="onEdit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button auth="market:poster:activity:delete">
          <el-button class="del" type="text" @click="onDelete(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index";
import tableList from '@/mixins/tableList'
import { api_postPostersList, api_putSwitchPosters, api_deletePosters } from '@/api/posterList'
import Table from "@/components/Table/index";
export default {
  name: "SCPosterList",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Table,
    Search,
  },
  data() {
    return {
      renderData: [
        {
          label: "专题编号",
          placeholder: "请输入专题编号",
          type: "input",
          isNumber: true,
          key: "id",
        },
        {
          label: "专题名称",
          placeholder: "请输入专题名称",
          type: "input",
          key: "name",
        },
        {
          label: "创建时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
      ],
      form: {},
      tableThData: [
        { prop: "id", label: "活动页编号", minWidth: "100", },
        { prop: "name", label: "标题名称", minWidth: "180", },
        { prop: "remark", label: "描述说明", minWidth: "180", },
        { prop: "createdTime", label: "创建时间", minWidth: "180", },
        { prop: "posterNum", label: "海报数量", minWidth: "100", },
        { prop: "disable", label: "状态", minWidth: "100", },
        { prop: "operation", label: "操作", minWidth: "180", },
      ],
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      if (this.form.time) {
        params.createTimeFrom = this.form.time ? this.form.time[0] * 1 : ''
        params.createTimeTo = this.form.time ? this.form.time[1] * 1 : ''
        delete params.time
      }
      const data = await api_postPostersList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击创建按钮
    onAdd() {
      this.$router.push({
        path: "/serverConfig/posterList/add"
      })
    },

    // 切换状态
    onSwitch(row) {
      console.log('row: ', row);
      this.$baseConfirm(
        row.disable ? '是否开启？' : '是否关闭？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_putSwitchPosters({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

    onDelete(row) {
      this.$baseConfirm(
        '是否删除该活动页？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_deletePosters({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

    onEdit(row){
      this.$router.push({
        path: "/serverConfig/posterList/add?id=" + row.id
      })
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.poster-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .del {
    color: #F74A4A;
  }
  ::v-deep{
    // 去除switch禁用 css
    .el-switch.is-disabled{
      opacity: 1;
    }
    .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label{
      cursor: pointer;
    }
  }
  .image{
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }

  .remark {
    width: 180px;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
